import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./Slice/authSlice";
import siteReducer from "./Slice/siteSlice";
import orderReducer from "./Slice/orderSlice";

// Redux store: auth (signed-in user), site (website list + overview), order (orders of one website)
export const Store = configureStore({
  reducer: {
    auth: authReducer,
    site: siteReducer,
    order: orderReducer,
  },
});

export default Store;
